import React from 'react'
import { Link } from 'react-router-dom'
import { config } from '../config'

const CtaSection = ({Line}) => {
    return (
        <div>
            <div className="rs-cleaning cleaning-style bg3 pt-100 pb-100 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="cleaning-part">
                        <div className="sec-title">
                            <h2 className="title title3">
                                Let’s Clean Your Premises<br /> <span>With Our</span> Experts
                            </h2>
                            <div className="line-img cleaner-center wow fadeInUp">
                                <img src={Line} alt="Images" />
                            </div>
                            <div className="btn-part mt-50">

                                <Link to={`${config.appUrl}contact-us`} className="readon view contact">Contact Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CtaSection
